// How many bottom sheets are open right now. Something that wants to open a sheet of its own (the check-out) waits
// until this is 0, so two sheets are never stacked (audit A6).
let count = 0;
const listeners = new Set<() => void>();

export const openSheetCount = (): number => count;

export function subscribeSheets(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Called by BottomSheet while it is open; the returned function says it closed. */
export function trackSheet(): () => void {
  count += 1;
  listeners.forEach((l) => l());
  return () => {
    count -= 1;
    listeners.forEach((l) => l());
  };
}
